import { render } from "./LanguageForm.vue?vue&type=template&id=6fbf12a5&ts=true"
import script from "./LanguageForm.vue?vue&type=script&lang=ts"
export * from "./LanguageForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__